<template>
  <div>
    <Toolbar />
    <div class="d-flex flex-column ma-0 pa-0 mt-md-5 mt-lg-5 mt-xl-5 px-5">
      <IconoHeader icono="email" />
      <v-row justify="center" class="ma-0 pa-0">
        <v-col cols="12" class="ma-0 pa-0">
          <h3 class="texto-titulo text-center font-weight-bold mt-5">
            ¡Excelente! <br />
            Ahora, captura tu correo
          </h3>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mt-5">
        <v-col
          cols="12"
          xs="12"
          sm="12"
          md="10"
          lg="10"
          xl="10"
          class="ma-0 pa-0"
        >
          <p
            class="text-body-2 text-center grey--text text--darken-2 ma-0 pa-0"
          >
            Deberás ingresar un correo electrónico al que puedas acceder,
            <span class="font-weight-bold"
              >ya que por este medio recibirás tus contratos una vez autorizado
              tu crédito.</span
            >
          </p>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mt-4">
        <v-col cols="12" class="ma-0 pa-0">
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-container>
              <v-row justify="center">
                <v-col cols="12" xs="12" sm="12" md="10" lg="10" xl="10">
                  <v-text-field
                    class="correoLower"
                    type="email"
                    outlined
                    v-model="correo"
                    label="Correo electronico"
                    required
                    placeholder="Ingresa tu correo electrónico"
                    :error-messages="emailErrors"
                    @input="$v.correo.$touch()"
                    @blur="$v.correo.$touch()"
                    hide-details="auto"
                  ></v-text-field>

                  <v-text-field
                    class="mt-5 correoLower"
                    type="email"
                    outlined
                    v-model="confirmaCorreo"
                    label="Confirmar correo electrónico"
                    required
                    placeholder="Ingresa el mismo correo"
                    :error-messages="confirmaEmailErrors"
                    @input="$v.confirmaCorreo.$touch()"
                    @blur="$v.confirmaCorreo.$touch()"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mt-2">
        <v-col cols="12" class="ma-0 pa-0 d-flex justify-center align-center">
          <v-btn
            class="align-self-center mt-0"
            color="primary"
            elevation="2"
            type="sumbmit"
            :disabled="!valid || cargando"
            :loading="cargando"
            @click="submit"
            >CONTINUAR<v-icon right light>mdi-arrow-right</v-icon></v-btn
          >
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import Toolbar from '@/components/compartidos/Toolbar.vue'
import IconoHeader from '@/components/compartidos/IconoHeader.vue'
import { validationMixin } from 'vuelidate'
import { required, email, sameAs } from 'vuelidate/lib/validators'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'
import { mapGetters, mapActions } from 'vuex'
// TODO: descomentar al re-habilitar actualizarCorreoPersona
// import Credito from '@/servicios/credito'
// import { ALERTA_ERROR } from '@/utilidades/utilidades'

export default {
  mixins: [validationMixin, InsertaLogMixin],
  components: {
    Toolbar,
    IconoHeader,
  },
  name: 'Correo',
  mounted() {
    this.InsertaLog()
  },
  data: () => ({
    correo: '',
    confirmaCorreo: '',
    valid: false,
    cargando: false,
  }),
  validations: {
    correo: {
      required,
      email,
    },
    confirmaCorreo: {
      required,
      sameAs: sameAs('correo'),
    },
  },
  computed: {
    ...mapGetters({
      obtenerPersona: 'persona/obtenerPersona',
      obtenerIdSolicitud: 'credito/obtenerIdSolicitud',
    }),
    emailErrors() {
      const errors = []
      if (!this.$v.correo.$dirty) return errors
      !this.$v.correo.email &&
        errors.push('El correo electrónico debe ser valido')
      !this.$v.correo.required &&
        errors.push('El correo electrónico es requerido')
      this.$gtag.event('correoErrors', {
        event_category: 'change_in_window',
        event_label: 'No fue valido el correo',
        value: errors[0],
      })
      return errors
    },
    confirmaEmailErrors() {
      const errors = []
      if (!this.$v.confirmaCorreo.$dirty) return errors
      !this.$v.confirmaCorreo.sameAs &&
        errors.push('Los correos deben coincidir')
      !this.$v.confirmaCorreo.required &&
        errors.push('La confirmación es requerida')
      this.$gtag.event('correoErrors', {
        event_category: 'change_in_window',
        event_label: 'No fue valido el correo',
        value: errors[0],
      })
      return errors
    },
  },
  methods: {
    async submit() {
      this.$v.$touch()
      if (this.$v.$invalid) return

      // TODO: mover al SP post-desembolso cuando backend indique
      // this.cargando = true
      // try {
      //   const numero = process.env.NODE_ENV === 'production'
      //     ? this.obtenerPersona.datosPersonales.numero
      //     : process.env.VUE_APP_NUMERO_SOCIO_QA
      //   await Credito.actualizarCorreoPersona({
      //     Numero: Number(numero),
      //     Correo: this.correo,
      //     IdSolicitud: this.obtenerIdSolicitud || 0,
      //   })
      // } catch {
      //   this.enviarAlertaError({
      //     mensaje: ALERTA_ERROR.mensaje,
      //     tiempo: ALERTA_ERROR.tiempo,
      //     visibilidad: ALERTA_ERROR.visible,
      //   })
      //   this.cargando = false
      //   return
      // }

      this.$store.dispatch('persona/establecerCorreo', this.correo)
      this.$store.dispatch('persona/establecerCorreoRegistrado', this.correo)
      this.cargando = false

      this.$router.push('/validar-correo')
    },
    clear() {
      this.$v.$reset()
    },
    ...mapActions({
      enviarAlertaError: 'alerta/enviarAlertaError',
    }),
  },
}
</script>
<style>
.correoLower input {
  text-transform: lowercase;
}
</style>
